import { useEffect, useState } from '@wordpress/element';
import AreaRenderer from '../areas/AreaRenderer';

const EnhancedPreviewCard = ({ sections }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  // Simple image load detection
  useEffect(() => {
    const image = new Image();
    image.src = 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80';
    
    image.onload = () => {
      setIsImageLoaded(true);
    };

    image.onerror = () => {
      setIsImageLoaded(true);
    };

    // Fallback
    const fallbackTimer = setTimeout(() => {
      setIsImageLoaded(true);
    }, 3000);

    return () => {
      clearTimeout(fallbackTimer);
    };
  }, []);

  return (
    <div className="hvnly--builder---api_property__builder___enhanced_preview_card">
      {/* Image Section */}
      <div className="hvnly--builder---api_property__builder___enhanced_preview_card_image_section">
        <div className={`hvnly--builder---api_property__builder___enhanced_preview_card_image ${!isImageLoaded ? 'loading' : ''}`}>
          
          {/* Background Image with Auto Blur Reduction */}
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_image_bg"></div>
          
          {/* Thumbnail Area */}
          <AreaRenderer 
            area="thumbnail"
            sections={sections}
            mode="enhanced-preview"
          />
          
          {/* Overlay Areas */}
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_image_overlay_top">
            <div className="hvnly--builder---api_property__builder___enhanced_preview_card_image_left">
              <AreaRenderer 
                area="top-left"
                sections={sections}
                mode="enhanced-preview"
              />
            </div>
            <div className="hvnly--builder---api_property__builder___enhanced_preview_card_image_right">
              <AreaRenderer 
                area="top-right"
                sections={sections}
                mode="enhanced-preview"
              />
            </div>
          </div>
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_image_overlay_bottom">
            <div className="hvnly--builder---api_property__builder___enhanced_preview_card_image_left">
              <AreaRenderer 
                area="bottom-left"
                sections={sections}
                mode="enhanced-preview"
              />
            </div>
            <div className="hvnly--builder---api_property__builder___enhanced_preview_card_image_right">
              <AreaRenderer 
                area="bottom-right"
                sections={sections}
                mode="enhanced-preview"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Rest of your existing code remains exactly the same */}
      <div className="hvnly--builder---api_property__builder___enhanced_preview_card_body">
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_header">
          <AreaRenderer 
            area="avatar"
            sections={sections}
            mode="enhanced-preview"
          />
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_title_section">
            <AreaRenderer 
              area="title"
              sections={sections}
              mode="enhanced-preview"
            />
          </div>
        </div>
        
        <AreaRenderer 
          area="excerpt"
          sections={sections}
          mode="enhanced-preview"
        />
        
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_features">
          <AreaRenderer 
            area="features"
            sections={sections}
            mode="enhanced-preview"
          />
        </div>
        
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_content_area">
          <AreaRenderer 
            area="content"
            sections={sections}
            mode="enhanced-preview"
          />
        </div>
      </div>
      
      {/* Fixed Footer Section */}
      <div className="hvnly--builder---api_property__builder___enhanced_preview_card_footer">
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_footer_left">
          <AreaRenderer 
            area="footer-left"
            sections={sections}
            mode="enhanced-preview"
          />
        </div>
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_footer_right">
          <AreaRenderer 
            area="footer-right"
            sections={sections}
            mode="enhanced-preview"
          />
        </div>
      </div>
    </div>
  );
};

export default EnhancedPreviewCard;